import styled from "@emotion/styled";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateTeams, singleTeams } from "../../../states/actions/teamsAction";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const UpdateTeams = () => {
  const imageInput = useRef(null);
  const [imageGallery, setImageGallery] = useState();

  const UploadBox = styled(Box)({
    marginTop: 30,
    height: 200,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderStyle: "dashed",
    borderWidth: "2px",
    borderColor: "divider",
  });

  // use form
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();
  const { id } = useParams();
  useEffect(() => {
    onReset();
  }, []);
  const onReset = async () => {
    const result = await dispatch(singleTeams(id));
    reset(result.payload);
  };
  // hooks
  const teams = useSelector((state) => state.teams);

  useEffect(() => {
    if (teams?.teams?.length !== null && teams?.teams !== undefined) {
      setImageGallery(teams?.teams?.photo);
    }
  }, [teams?.teams]);

  // variable declaration
  const [picture1, setPicture1] = useState(null);
  const [getImg1, setImg1] = useState(null);

  // when image is uploaded
  const onImageUpload1 = (e) => {
    e.persist();
    setPicture1(URL.createObjectURL(e.target.files[0]));
    setImg1(e.target.files[0]);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (data, e) => {
    data.photo = getImg1;
    const formData = new FormData();
    Object?.entries(data).map((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });

    dispatch(updateTeams({ formData: formData, id: id }));
    reset();
    setTimeout(function () {
      navigate("/all-teams");
    }, 2000);
  };
  const { t: translate } = useTranslation(["teams"]);
  return (
    <Layout title={"Teams"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h6" sx={{ marginBottom: "14px" }}>
          {translate("Update Member Information")}
        </Typography>
        <Paper
          sx={{
            boxShadow: "none !important",
            borderRadius: "12px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            p: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 4 }}>
              <div className="w-full">
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register(`name`, {
                    required: true,
                    maxLength: 1000,
                    pattern: /^[A-Za-z\s]+$/,
                  })}
                />
                {errors.name && (
                  <p className="text-red-500">
                    {" "}
                    {translate("name is invalid")}{" "}
                  </p>
                )}
              </div>
              <div className="w-full">
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register(`position`, {
                    required: true,
                    maxLength: 1000,
                    // pattern: /^[A-Za-z\s]+$/,
                  })}
                />
                {errors.position && (
                  <p className="text-red-500">
                    {" "}
                    {translate("position is invalid")}{" "}
                  </p>
                )}
              </div>
            </Box>
            <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 4 }}>
              <div className="w-full">
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register(`linkedn`, {
                    required: true,
                  })}
                />
                {errors.linkedn && (
                  <p className="text-red-500">
                    {" "}
                    {translate("linkedn url is invalid")}{" "}
                  </p>
                )}
              </div>
              <div className="w-full">
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register(`twitter`)}
                />
              </div>
            </Box>

            <Box sx={{ mt: 3 }}>
              <TextField
                variant="outlined"
                rows={3}
                fullWidth
                multiline
                {...register(`teamMemberBio`, {
                  required: true,
                  // maxLength: 10000,
                })}
              />
              {errors.teamMemberBio && (
                <p className="text-red-500">
                  {" "}
                  {translate("Team Member Bio is required")}
                </p>
              )}
            </Box>

            <input
              // type="file"
              hidden
              ref={imageInput}
              //onChange={(e) => setImage(e.target.files[0])}
              type="file"
              accept="image/*"
              onChange={onImageUpload1}
            />
            <UploadBox onClick={() => imageInput.current.click()}>
              {getImg1 ? (
                <img
                  src={picture1}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={`${BaseUrl}${imageGallery}`}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </UploadBox>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "30px",
              }}
            >
              <Button
                variant="contained"
                sx={{ borderRadius: "5px" }}
                type="submit"
              >
                {translate("Update Member Info")}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UpdateTeams;
